// import React, { useState, useEffect } from 'react';
// import { Navbar, Nav, Offcanvas } from 'react-bootstrap';
// import { ScrollSpy } from 'bootstrap';

// import { FaBars } from 'react-icons/fa';
// import 'bootstrap/dist/js/bootstrap.bundle.min'; // Ensure Bootstrap JS is imported
// import './LeftSideNavBarScrollSpy_v03.css';

// const LeftSideNavScrollSpy_v03: React.FC = () => {
//   const [show, setShow] = useState<boolean>(false);
//   const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const updateMedia = () => {
//     setIsMobile(window.innerWidth < 768);
//     if (window.innerWidth >= 768) {
//       setShow(false);
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('resize', updateMedia);
//     return () => window.removeEventListener('resize', updateMedia);
//   }, []);

//   // Initialize scrollspy
//   useEffect(() => {
//     const scrollSpy = new (window as any).bootstrap.ScrollSpy(
//       document.querySelector('.content-container') as HTMLElement,
//       {
//         target: '.side-nav',
//         offset: 70,
//       }
//     );

//     return () => {
//       scrollSpy.dispose(); // Clean up scrollspy instance on component unmount
//     };
//   }, []);

//   return (
//     <div className="app-container">
//       {isMobile && (
//         <button onClick={handleShow} className="hamburger-btn">
//           <FaBars size={24} />
//         </button>
//       )}

//       <Offcanvas show={show || !isMobile} onHide={handleClose} responsive="lg" className="side-nav">
//         <Offcanvas.Header closeButton={isMobile}>
//           <Offcanvas.Title>Menu</Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <Nav className="flex-column" as="ul">
//             <Nav.Item as="li">
//               <Nav.Link href="#home" className="nav-link" data-bs-toggle="scroll">
//                 Home
//               </Nav.Link>
//             </Nav.Item>
//             <Nav.Item as="li">
//               <Nav.Link href="#about" className="nav-link" data-bs-toggle="scroll">
//                 About
//               </Nav.Link>
//             </Nav.Item>
//             <Nav.Item as="li">
//               <Nav.Link href="#services" className="nav-link" data-bs-toggle="scroll">
//                 Services
//               </Nav.Link>
//             </Nav.Item>
//             <Nav.Item as="li">
//               <Nav.Link href="#contact" className="nav-link" data-bs-toggle="scroll">
//                 Contact
//               </Nav.Link>
//             </Nav.Item>
//           </Nav>
//         </Offcanvas.Body>
//       </Offcanvas>

//       <div className="content-container" data-bs-spy="scroll" data-bs-target=".side-nav" data-bs-offset="70" tabIndex={0}>
//         <section id="home" className="section">
//           <h2>Home Section</h2>
//           <p>Welcome to the Home section.</p>
//         </section>

//         <section id="about" className="section">
//           <h2>About Section</h2>
//           <p>Information about us goes here.</p>
//         </section>

//         <section id="services" className="section">
//           <h2>Services Section</h2>
//           <p>Details about our services are provided here.</p>
//         </section>

//         <section id="contact" className="section">
//           <h2>Contact Section</h2>
//           <p>Contact us for more information.</p>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default LeftSideNavScrollSpy_v03;





import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Offcanvas } from 'react-bootstrap';

import 'bootstrap-icons/font/bootstrap-icons.css';

import './LeftSideNavBarScrollSpy_v03.css';

import { FaBars } from 'react-icons/fa';
import type { IconType } from 'react-icons';

const IconFaBars = FaBars as IconType;



const LeftSideNavScrollSpy_v03: React.FC = () => {

//const IconFaBars = FaBars as unknown as React.FC<React.SVGProps<SVGSVGElement>>;


  const [show, setShow] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const updateMedia = () => {
    setIsMobile(window.innerWidth < 768);
    if (window.innerWidth >= 768) {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);

  return (
    <div className="app-container">
      {isMobile && (
        <button onClick={handleShow} className="hamburger-btn">
          <i className="bi bi-list"></i>
          {/* <IconFaBars size={24} /> */}
        </button>
      )}

      <Offcanvas show={show || !isMobile} onHide={handleClose} responsive="lg" className="side-nav">
        <Offcanvas.Header closeButton={isMobile}>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column" as="ul">
            <Nav.Item as="li">
              <Nav.Link href="#home" className="nav-link" data-bs-toggle="scroll">
                Home
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link href="#about" className="nav-link" data-bs-toggle="scroll">
                About
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link href="#services" className="nav-link" data-bs-toggle="scroll">
                Services
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link href="#contact" className="nav-link" data-bs-toggle="scroll">
                Contact
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      <div className="content-container" data-bs-spy="scroll" data-bs-target=".side-nav" data-bs-offset="70" tabIndex={0}>
        <section id="home" className="section">
          <h2>Home Section</h2>
          <p>Welcome to the Home section.</p>
        </section>

             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>

        <section id="about" className="section">
          <h2>About Section</h2>
          <p>Information about us goes here.</p>
        </section>

        <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>


        <section id="services" className="section">
          <h2>Services Section</h2>
          <p>Details about our services are provided here.</p>
        </section>

        <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>


        <section id="contact" className="section">
          <h2>Contact Section</h2>
          <p>Contact us for more information.</p>
        </section>

        <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>


      </div>
    </div>
  );
};

export default LeftSideNavScrollSpy_v03;




// import React, { useState, useEffect } from 'react';
// import { Navbar, Nav, Offcanvas } from 'react-bootstrap';
// import { FaBars } from 'react-icons/fa';
// import './LeftSideNavBarScrollSpy_v03.css';

// const LeftSideNavScrollSpy_v03: React.FC = () => {
//   const [show, setShow] = useState<boolean>(false);
//   const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const updateMedia = () => {
//     setIsMobile(window.innerWidth < 768);
//     if (window.innerWidth >= 768) {
//       setShow(false);
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('resize', updateMedia);
//     return () => window.removeEventListener('resize', updateMedia);
//   }, []);

//   return (
//     <div className="app-container">
//       {isMobile && (
//         <button onClick={handleShow} className="hamburger-btn">
//           <FaBars size={24} />
//         </button>
//       )}

//       <Offcanvas show={show || !isMobile} onHide={handleClose} responsive="lg" className="side-nav">
//         <Offcanvas.Header closeButton={isMobile}>
//           <Offcanvas.Title>Menu</Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <Nav className="flex-column" as="ul">
//             <Nav.Item as="li">
//               <Nav.Link href="#home" className="nav-link" data-bs-toggle="scroll">
//                 Home
//               </Nav.Link>
//             </Nav.Item>

            
//             <Nav.Item as="li">
//               <Nav.Link href="#about" className="nav-link" data-bs-toggle="scroll">
//                 About
//               </Nav.Link>
//             </Nav.Item>

      
//             <Nav.Item as="li">
//               <Nav.Link href="#services" className="nav-link" data-bs-toggle="scroll">
//                 Services
//               </Nav.Link>
//             </Nav.Item>
      

//             <Nav.Item as="li">
//               <Nav.Link href="#contact" className="nav-link" data-bs-toggle="scroll">
//                 Contact
//               </Nav.Link>
//             </Nav.Item>

       
      
//           </Nav>
//         </Offcanvas.Body>
//       </Offcanvas>

//       <div className="content-container" data-bs-spy="scroll" data-bs-target=".side-nav" data-bs-offset="70" tabIndex={0}>
//         <section id="home" className="section">
//           <h2>Home Section</h2>
//           <p>Welcome to the Home section.</p>
//         </section>

//         <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>

//         <section id="about" className="section">
//           <h2>About Section</h2>
//           <p>Information about us goes here.</p>
//         </section>

//         <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>

//         <section id="services" className="section">
//           <h2>Services Section</h2>
//           <p>Details about our services are provided here.</p>
//         </section>

//         <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//         <section id="contact" className="section">
//           <h2>Contact Section</h2>
//           <p>Contact us for more information.</p>
//         </section>

//         <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>
//             <br></br><br></br><br></br><br></br><br></br><br></br><br></br>



//       </div>
//     </div>
//   );
// };

// export default LeftSideNavScrollSpy_v03;
